import { ContactFormData } from './types'

export const initialValues: ContactFormData = {
  firstName: '',
  lastName: '',
  company: '',
  email: '',
  phoneNumber: '',
  country: '',
  message: ''
}
